import React from "react";
import {setPeriod} from "../../../../slices/statisticsSlice";
import {PeriodSelectors} from "./PeriodSelectors";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useWindowWidth} from "../../../../hooks/useWindowWidth";
import Select from "react-select";
import {PeriodModeSelectors} from "./PeriodModeSelectors";
import {dateStyles} from "../../../../selectStyles";
import {CustomNoOptionsMessage} from "../../cms/form-components/CustomNoOptionsMessage";
import {usePeriodModes} from "../../../../hooks/usePeriodModes";
import {setRestaurantContextMenuActive} from "../../../../slices/restaurantSlice";

export const PeriodicSummaryHeader = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {period: periodObject} = useSelector(state => state.statistics.view);
    const width = useWindowWidth();
    const isWide = width > 1300;
    const periodModes = usePeriodModes();
    const period = periodObject?.value;

    return (
        <header className={'statistics-periodic-summary'}>
            <div className={'period-mode-wrapper'}>
                <span className={'summary-text'}>{t('summary')}</span>
                {isWide && <PeriodModeSelectors/>}
                {!isWide &&
                    <Select id={'period-mode'}
                            name={'period-mode'}
                            value={periodObject}
                            placeholder={t('choose')}
                            options={periodModes}
                            isSearchable={false}
                            onChange={(selected) => dispatch(setPeriod(selected))}
                            onMenuOpen={() => dispatch(setRestaurantContextMenuActive(false))}
                            onFocus={() => dispatch(setRestaurantContextMenuActive(false))}
                            styles={dateStyles}
                            components={{NoOptionsMessage: CustomNoOptionsMessage}}
                    />
                }
            </div>
            <div className={'period-picker-wrapper'} style={period === 'day' ? {gap: 0} : {}}>
                <PeriodSelectors/>
            </div>
        </header>
    );
}